import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmSmsMessageTooLongError } from '@/core/error/transport/TmSmsMessageTooLongError'

export const smsMessageTooLongErrorRule: CustomErrorRule = {
  klass: TmSmsMessageTooLongError,
  endpoint: EndpointsEnum.messagesPrice,
  predicateFn: (error) => {
    const errors = error.response.data.errors
    if (!errors || !errors.fields || !errors.fields.text) {
      return false
    }
    const fieldText = errors.fields.text
    if (!Array.isArray(fieldText)) {
      return false
    }
    const fieldTextFirst = fieldText[0]
    return fieldTextFirst.includes('Message text should not exceed')
  },
}
